export function isHubSupportTicketSuggestion(kind: string | null | undefined): boolean {
  return kind === "suggestion";
}

/** Long suggestion labels stay sentence case; bug labels stay the compact uppercase style. */
export function hubSupportTicketFieldLabelClassName(kind: string | null | undefined): string {
  return isHubSupportTicketSuggestion(kind)
    ? "mb-1 block text-xs font-medium text-slate-500"
    : "mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500";
}

/** Labels the reporter sees on the new-ticket form and on their own ticket. */
export function hubSupportTicketReporterFieldCopy(kind: string | null | undefined): {
  actualLabel: string;
  expectedLabel: string;
  actualPlaceholder: string;
  expectedPlaceholder: string;
} {
  if (isHubSupportTicketSuggestion(kind)) {
    return {
      actualLabel: "What are you suggesting",
      expectedLabel: "Describe a workflow where you would use this",
      actualPlaceholder: "Name the change or feature you want.",
      expectedPlaceholder: "Walk through a real task where this would help.",
    };
  }
  return {
    actualLabel: "What happened",
    expectedLabel: "What did you expect it to do",
    actualPlaceholder: "Describe what you saw, including steps if you can.",
    expectedPlaceholder: "Describe the correct or desired behavior.",
  };
}

/** Labels staff see when reading a ticket (third person). */
export function hubSupportTicketReviewerFieldCopy(kind: string | null | undefined): {
  actualLabel: string;
  expectedLabel: string;
} {
  if (isHubSupportTicketSuggestion(kind)) {
    return {
      actualLabel: "What they are suggesting",
      expectedLabel: "Workflow where they would use this",
    };
  }
  return {
    actualLabel: "What happened",
    expectedLabel: "What they expected",
  };
}
